import { Shirt, Gamepad2, ShoppingCart, Megaphone, Cpu, Trophy, Palette, Globe } from "lucide-react";

// Suggested media per topic. Subsection domains with a path (e.g. as.com/meristation,
// shopify.com/es/blog) are intentionally omitted for now to avoid feed-detection errors.
export const TOPICS = [
  {
    key: "moda",
    label: "Moda y Tendencias",
    icon: Shirt,
    media: [
      { name: "Vogue España", domain: "vogue.es" },
      { name: "Elle España", domain: "elle.es" },
      { name: "S Moda", domain: "smoda.elpais.com" },
      { name: "Telva", domain: "telva.com" },
      { name: "Modaes", domain: "modaes.com" },
    ],
  },
  {
    key: "gaming",
    label: "Gaming",
    icon: Gamepad2,
    media: [
      { name: "Vandal", domain: "vandal.elespanol.com" },
      { name: "3DJuegos", domain: "3djuegos.com" },
      { name: "Eurogamer España", domain: "eurogamer.es" },
      { name: "IGN España", domain: "es.ign.com" },
    ],
  },
  {
    key: "ecommerce",
    label: "Ecommerce",
    icon: ShoppingCart,
    media: [
      { name: "Ecommerce News España", domain: "ecommercenews.es" },
      { name: "Marketing4eCommerce", domain: "marketing4ecommerce.net" },
      { name: "Just Retail", domain: "just-retail.org" },
      { name: "Food Retail & Shopper", domain: "foodretail.es" },
    ],
  },
  {
    key: "marketing",
    label: "Marketing y Publicidad",
    icon: Megaphone,
    media: [
      { name: "MarketingDirecto", domain: "marketingdirecto.com" },
      { name: "Reason Why", domain: "reasonwhy.es" },
      { name: "PuroMarketing", domain: "puromarketing.com" },
      { name: "Anuncios", domain: "anuncios.com" },
      { name: "Control Publicidad", domain: "controlpublicidad.com" },
    ],
  },
  {
    key: "tecnologia",
    label: "Tecnología",
    icon: Cpu,
    media: [
      { name: "Xataka", domain: "xataka.com" },
      { name: "Genbeta", domain: "genbeta.com" },
      { name: "Hipertextual", domain: "hipertextual.com" },
      { name: "El Output", domain: "eloutput.com" },
      { name: "Computer Hoy", domain: "computerhoy.com" },
    ],
  },
  {
    key: "deporte",
    label: "Deporte",
    icon: Trophy,
    media: [
      { name: "Marca", domain: "marca.com" },
      { name: "AS", domain: "as.com" },
      { name: "Mundo Deportivo", domain: "mundodeportivo.com" },
      { name: "Relevo", domain: "relevo.com" },
      { name: "Sport", domain: "sport.es" },
    ],
  },
  {
    key: "cultura",
    label: "Cultura",
    icon: Palette,
    media: [
      { name: "Jot Down", domain: "jotdown.es" },
      { name: "ArchDaily en Español", domain: "archdaily.es" },
      { name: "MondoSonoro", domain: "mondosonoro.com" },
    ],
  },
  {
    key: "actualidad",
    label: "Actualidad",
    icon: Globe,
    media: [
      { name: "El País", domain: "elpais.com" },
      { name: "El Mundo", domain: "elmundo.es" },
      { name: "El Confidencial", domain: "elconfidencial.com" },
      { name: "elDiario.es", domain: "eldiario.es" },
      { name: "ABC", domain: "abc.es" },
    ],
  },
];

export const mediaName = (domain) => {
  const root = domain.replace(/^https?:\/\//, "").replace(/^www\./, "").split(".")[0] || domain;
  return root.charAt(0).toUpperCase() + root.slice(1);
};

// Minimum media to finish onboarding (variety avoids repeating content in the newsletter).
export const MIN_MEDIA = 5;

export const FREQUENCIES = [
  { key: "daily", label: "Diario", desc: "Un resumen cada mañana." },
  { key: "twice_week", label: "Dos veces por semana", desc: "Lunes y miércoles.", recommended: true },
  { key: "weekly", label: "Semanal", desc: "Un resumen cada lunes." },
  { key: "off", label: "Sin correos por ahora", desc: "Podrás activarlos cuando quieras en Ajustes." },
];

export const frequencyLabel = (key) => (FREQUENCIES.find((f) => f.key === key) || {}).label || key;
